/**
 * Match specific file types under directory starting with 'assets'
 */
const internalFiles = new RegExp(/^[/]?assets[-\w]*[/\w-]*(?:.pdf|.json)+$/);

/**
 * Forces links matching regex to open in a new tab
 */
export const LINK_NEW_TAB_REGEXP_WHITELIST: ReadonlyArray<RegExp> = [
  internalFiles,
];

export interface LinkTargetWhitelist {
  destination: string;
  source?: string; // when defined, usage must match both source and destination
}

/**
 * Forces internal links to open in a new tab
 */
export const LINK_NEW_TAB_WHITELIST: ReadonlyArray<LinkTargetWhitelist> = [
  // Bits button-link story
  {
    source: '/components/button/button-link',
    destination: '/components',
  },
  // Bits link story
  {
    source: '/components/link/default',
    destination: '/components/button',
  },
];

/**
 * Forces external links to open in a same tab
 */
export const LINK_SAME_TAB_WHITELIST: ReadonlyArray<LinkTargetWhitelist> = [];
